import { IgChip, IgRadio, IgTypography } from "@intelligems/ig-theme";
import { Box, Stack } from "@mui/material";

interface MobileVariationCardProps {
  variation: {
    id: string;
    name: string;
    isControl: boolean;
  };
  selected: boolean;
  onSelect: (id: string) => void;
  showMetrics?: boolean;
  metrics?: {
    conversion?: number;
    revenue?: number;
  };
}

export const MobileVariationCard = ({
  variation,
  selected,
  onSelect,
  showMetrics = false,
  metrics,
}: MobileVariationCardProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      onClick={() => onSelect(variation.id)}
    >
      <IgRadio checked={selected} value={variation.id} />
      <Stack spacing={3} justifyContent="center" sx={{ flex: 1, minHeight: 0 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <IgTypography
            variant="body1"
            sx={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {variation.name}
          </IgTypography>
          {variation.isControl && <IgChip label="Control" />}
        </Stack>

        {showMetrics && metrics && (
          <Stack spacing={1}>
            {metrics.conversion !== undefined && (
              <IgTypography variant="caption" color="text.secondary">
                Conversion: {(metrics.conversion * 100).toFixed(2)}%
              </IgTypography>
            )}
            {metrics.revenue !== undefined && (
              <IgTypography variant="caption" color="text.secondary">
                Revenue: ${metrics.revenue.toFixed(2)}
              </IgTypography>
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
